import { colors } from 'theme'
import { makeStyles } from 'tss-react/mui'

export const useTabStyles = makeStyles()((theme) => ({
  root: {
    minHeight: '40px',
  },
  list: {
    display: 'flex',
    alignItems: 'center',
    margin: 0,
    padding: 0,
  },
  listItem: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    listStyle: 'none',
    minWidth: 'auto',
    minHeight: '40px',
    padding: theme.spacing(1, 2.5),

    color: colors.tabsColor,
    fontSize: 16,
    fontWeight: 400,
    '&:hover': {
      color: colors.tabsColorHover,
      '::after': {
        width: '80%',
        background: colors.tabsColorUnderline,
      },
    },
    '&.Mui-selected': {
      color: colors.tabsColorSelected,
      fontWeight: 700,
      '::after': {
        width: '80%',
        background: theme.palette.primary.main,
      },
    },
    '&:has(a:focus-visible)': {
      color: colors.tabsColorSelected,
      backgroundColor: theme.palette.grey[300],
      '::after': {
        background: theme.palette.primary.main,
      },
    },
    // Indicator
    '::after': {
      background: theme.palette.primary.main,
      position: 'absolute',
      height: 5,
      width: 0, // Indicator hidden when not hovered or selected
      bottom: 0,
      content: '""',
      pointerEvents: 'none',
      borderRadius: theme.border.radius(),
    },
  },
  link: {
    color: 'inherit',
    fontWeight: 'inherit',
    textDecoration: 'none',
  },
}))
